import React from 'react';
import { Content, ButtonToolbar } from 'rsuite';
import InventoryPageLayout from '../../../containers/inventory/PageLayout';
import PageHeader from '../../../components/PageHeader';
import InventoryItemsAvailabilityList from '../../../containers/inventory/ItemsAvailabilityList';
import { ItemType } from '../../../constants/inventory/InventoryTypes';
import ItemAvailabilitySearch from '../../../containers/inventory/ItemAvailabilitySearch';

export default () => (
  <InventoryPageLayout>
    <PageHeader title="Items Availability">
      <ButtonToolbar>
        <ItemAvailabilitySearch type={ItemType} />
      </ButtonToolbar>
    </PageHeader>
    <Content>
      <InventoryItemsAvailabilityList />
    </Content>
  </InventoryPageLayout>
);
